import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const SectionSix = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div>
      <div className="cc-network-sec6" style={{ padding: isMobile && "0px" }}>
        <h1 style={{ lineHeight: "1.3" }}>Not Just a Checkout But Your</h1>
        <h1
          style={{
            color: "#042A4D",
            fontWeight: 600,
          }}
        >
          Business Growth Engine
        </h1>
        {/* <p>Access the largest network of online shoppers to boost engagement and conversions</p> */}

        <div className="cc-net-card">
          <div className="cc-outer-sec6">
            <div className="cc-inner-sec6 woo-net-card1">
              <img
                src="/assets/images/custom-checkout/frame1-sec6.png"
                alt=""
              />
              <div>
                <h5 style={{ color: "#191D23" }}>Optimize Shipping Rules</h5>
                <p style={{ color: "#38485C" }}>
                  Set fees & methods based on cart value, payment type, or
                  pincode — no code required.
                </p>
                <div
                  className="flex"
                  style={{ flexDirection: "column", marginTop: "15px" }}
                >
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Pincode-level rules</p>
                  </div>
                  <div className="flex pointer-sec6 ">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Order-range-based methods</p>
                  </div>
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Static EDD support</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cc-outer-sec6">
            <div className="cc-inner-sec6 woo-net-card2">
              <img
                src="/assets/images/custom-checkout/frame2-sec6.png"
                alt=""
              />
              <div>
                <h5 style={{ color: "#191D23" }}>Flexible Payment Options</h5>
                <p style={{ color: "#38485C" }}>
                  From UPI to No Cost EMI, support every mode that converts.
                </p>
                <div
                  className="flex"
                  style={{ flexDirection: "column", marginTop: "15px" }}
                >
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>UPI, Credit/Debit Cards, Net Banking, COD</p>
                  </div>
                  <div className="flex pointer-sec6 ">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Buy Now, Pay Later — Snapmint, Simpl</p>
                  </div>
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>No Cost EMI + Instant discounts</p>
                  </div>
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>All major bank offers supported</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cc-outer-sec6">
            <div className="cc-inner-sec6 woo-net-card3">
              <img
                src="/assets/images/custom-checkout/frame3-sec6.png"
                alt=""
              />
              <div>
                <h5 style={{ color: "#191D23" }}>Automate Cart Recovery</h5>
                <p style={{ color: "#38485C" }}>
                  With KwikEngage, send automated cart reminders on WhatsApp and
                  boost conversions.
                </p>
                <div
                  className="flex"
                  style={{ flexDirection: "column", marginTop: "15px" }}
                >
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Automated WhatsApp flows</p>
                  </div>
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Higher open & recovery rates</p>
                  </div>
                  <div className="flex pointer-sec6">
                    <img
                      src="/assets/images/custom-checkout/check-sec6.png"
                      alt=""
                    />
                    <p>Boost repeat purchases</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
